import { Component, AfterViewInit } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
	selector: 'image-preview',
	templateUrl: 'image-preview.html'
})
export class ImagePreviewComponent implements AfterViewInit{

	private detail:any;

	constructor(
		private navParams: NavParams,
		private sanitize: DomSanitizer,
		private viewCtrl: ViewController
	) {

		this.detail = this.navParams.get("data");
		this.detail.disimage = this.sanitize.bypassSecurityTrustResourceUrl(this.detail.filepath);
	}

	ngAfterViewInit() {

	}

	close() {
		this.viewCtrl.dismiss({
			action: "CLOSE",
			data: null
		})
	}

	delete() {
		this.viewCtrl.dismiss({
			action: "DELETE",
			data: this.detail
		})
	}

}



// WEBPACK FOOTER //
// ./src/components/image-preview/image-preview.ts